import React from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';

import { useDepositSuccessResult } from '../../../../hooks/use-deposit-success-result.hook';

export const ItemCountsInfo = () => {
  const { itemCounts, translations } = useDepositSuccessResult();

  return (
    <>
      {itemCounts.bowls > 0 && (
        <HStack w="100%" spacing="auto" pt={2}>
          <Box w="50%">{translations('bowls')}</Box>
          <Text>{itemCounts.bowls}</Text>
        </HStack>
      )}
      {itemCounts.cups > 0 && (
        <HStack w="100%" spacing="auto" pt={2}>
          <Box w="50%">{translations('cups')}</Box>
          <Box w="50%">
            <Text>{itemCounts.cups}</Text>
          </Box>
        </HStack>
      )}
      {itemCounts.pizzaBoxes > 0 && (
        <HStack w="100%" spacing="auto" pt={2}>
          <Box w="50%">{translations('pizza_boxes')}</Box>
          <Box w="50%">
            <Text>{itemCounts.pizzaBoxes}</Text>
          </Box>
        </HStack>
      )}
    </>
  );
};
